import { IChangeListItemTextProps } from "./ChangeListItemTypes"

import { Text, Flex } from "@chakra-ui/react"

const ChangeListItemText: React.FC<IChangeListItemTextProps> = ({ title, value }) => {
  return (
    <>
      <Text mb={"8px"} fontSize="base">
          {title}
      </Text>
      <Flex padding={"16px"} borderRadius={"10px"} align={"center"} justifyContent="center" bgColor={"#fff"}>
          <Text fontSize="base">{value || "-"}</Text>
      </Flex>
    </>
  )
}

export default ChangeListItemText